// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBarComponent_wrapper__KO2sL","hamburgerButton":"NavBarComponent_hamburgerButton__4+o5h","title":"NavBarComponent_title__TS0K9"};